"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = capitalizeString;
function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
module.exports = exports["default"];


/** WEBPACK FOOTER **
 ** ./~/inline-style-prefixer/utils/capitalizeString.js
 **/